import styled from "styled-components";

const Divider = styled.div`
  width: 100%;
  opacity: 0.05;
  border-bottom: 1px solid #000000;
  height: 0px;
`;

export default Divider;
